const roles = { owner: 'Proprietário', admin: 'Administrador', manager: 'Gestor', gestor: 'Gestor', editor: 'Editor', viewer: 'Leitor', comum: 'Membro', membro: 'Membro', responsavel: 'Responsável' }
const validDate = value => value && Number.isFinite(new Date(value).getTime())

export function profileAccountDetails({ user, profile, memberships = [], activeOrganizationId, selectedClient }) {
  const organizationId = activeOrganizationId || selectedClient?.organization_id
  const membership = memberships.find(item => item.organization_id === organizationId && item.is_active !== false)
  const client = selectedClient?.organization_id === organizationId ? selectedClient : null
  const joined = membership?.joined_at
  const created = validDate(profile?.created_at) ? profile.created_at : user?.created_at
  const date = validDate(joined) ? joined : created
  const role = membership?.role || client?.role
  return {
    phone: profile ? profile.phone : user?.user_metadata?.phone || user?.phone || null,
    organization: membership?.organization_name || client?.organization_name || 'Não informada',
    role: roles[role] || 'Não informado',
    roleScope: membership ? 'na organização' : client ? 'na conta' : '',
    dateLabel: validDate(joined) ? 'Membro desde' : 'Cadastro criado em',
    date: validDate(date) ? new Date(date).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' }) : 'Não informada',
  }
}
